'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
const StyledSmall = styled(Small).withConfig({
  displayName: "BinaryField__StyledSmall",
  componentId: "st2w0h-0"
})(["font-style:italic;"]);
export default class BinaryField extends Component {
  render() {
    const {
      schema
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(StyledSmall, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `developer-docs-shared-components.params.errors.fileType.${schema.format}`
        })
      })
    });
  }

}